import type { CollectionNode, FieldNode, GroupNode, MessageChannels, ValidationNode } from './types';

export function isFieldNode(node: ValidationNode): node is FieldNode {
    return !!(node as FieldNode)?.rules && !('$group' in (node as any)) && !('$collection' in (node as any));
}

export function isGroupNode(node: ValidationNode): node is GroupNode {
    return !!(node as any)?.$group;
}

export function isCollectionNode(node: ValidationNode): node is CollectionNode {
    return !!(node as any)?.$collection;
}

export function isMessageChannels(messages: unknown): messages is MessageChannels {
    return typeof messages === 'object' && messages !== null && ('inline' in (messages as any) || 'gcalert' in (messages as any));
}
